<svg width="41" height="50" viewBox="0 0 41 50" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.98734 39.9129C1.98734 39.9129 2.32233 39.5102 3.58842 39.6733C4.31963 39.7674 5.44705 39.8745 6.53884 39.9783C10.5308
      42.1807 15.4403 43.1456 19.8742 43.1898C25.2664 43.2436 29.4016 42.4086 32.5691 41.0333C34.5009 41.0193 36.3379 41.0333 37.9007
      41.1606C39.3865 41.2826 39.5815 41.7807 39.5815 41.7807C39.5815 41.7807 40.1647 42.2794 39.9745 43.4587C39.8274 44.363 39.6557
      45.6433 39.5076 46.5544C39.4016 47.2591 39.084 47.9145 38.5973 48.4329C38.5973 48.4329 38.4512 48.7493 37.232 48.8112C30.8128
      49.1367 11.4833 49.2139 4.51628 49.5661C3.05614 49.64 2.58215 49.2617 2.58215 49.2617C2.58215 49.2617 2.15095 49.0013 2.07935
      47.957C1.92773 45.7523 1.66596 43.8705 1.503 41.4955C1.41683 40.2394 1.98734 39.9129 1.98734 39.9129Z"
    fill="#875140" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M38.3271 24.7698C38.1399 24.7282 37.9973 24.1321 37.9685 23.4941C37.3487 9.88426 25.179 3.204 19.2911 0.75807C17.3972
      -0.029029 16.7444 0.222599 16.7444 0.222599C16.3319 0.317975 16.2785 1.19915 16.3533 1.88274C16.7745 5.74206 16.5503 9.66975
      14.7441 13.6856C14.3401 14.5837 13.8555 15.3751 13.239 15.3256C12.6471 15.3608 12.2544 14.2407 11.6881 13.3911C10.1761 11.1229
      8.54556 9.76675 7.50302 8.78304C6.61922 7.94907 6.39699 8.32471 6.39699 8.32471C6.39699 8.32471 5.92334 8.38688 6.26546
      9.40445C6.38349 9.88365 6.44246 10.3756 6.44105 10.8693C6.50584 12.531 6.14558 14.7569 4.59212 17.2917C3.42226 19.1989 -1.50699
      25.4586 1.97086 32.7567C5.13089 39.3862 13.2127 41.9919 20.0486 42.0639C40.4974 42.2794 41.1418 27.6848 40.6533 22.5521C40.5606
      21.5794 40.0406 21.4128 39.7241 21.5133C39.2187 21.6784 39.2825 22.3356 39.2705 22.7142C39.209 24.8183 38.3271 24.7698 38.3271
      24.7698Z"
    fill="#F39C67" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17.3796 19.5245C17.412 19.1901 17.5266 18.8691 17.713 18.5903C17.713 18.5903 18.0905 18.5115 18.7659 19.2534C19.0594 19.5762
      19.3222 19.9259 19.5509 20.2979C19.7129 20.5629 19.8101 20.8555 20.0434 20.8689C20.1996 20.6051 20.323 20.3231 20.4107
      20.0291C20.9326 18.2499 21.2839 16.4247 21.4598 14.5783C21.5132 14.0604 21.4922 13.9243 21.799 13.562C22.3044 13.5884 22.3672
      13.7248 22.7757 14.1154C25.8671 17.0841 29.4428 22.4301 29.7305 27.7731C29.7629 28.3766 29.723 28.8571 29.85 28.9951C29.85
      28.9951 30.0266 29.1758 30.4591 28.4791C30.8046 27.9225 31.1142 27.3442 31.386 26.7477C31.5804 26.3171 31.616 26.0026 31.8395
      25.874C32.1143 25.8955 32.1817 26.2578 32.2753 26.861C32.8863 30.7975 30.048 39.0122 20.5416 39.0122C16.0151 39.0122 11.1804
      37.329 9.54632 32.6266C8.00939 28.2028 11.4467 19.7446 12.2133 19.8188C13.005 19.8949 11.9648 27.0872 14.9265 27.6933C16.5305
      27.9889 17.1872 20.3767 17.3796 19.5245Z"
    fill="#FFDCA9" />
</svg>
